// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__+JTSP","tab":"tabs_tab__XJVuV","tabIcon":"tabs_tabIcon__dHG2f","selected":"tabs_selected__Y0Pha","disabled":"tabs_disabled__F-FG2"};